import fp from "lodash/fp";

import { withResetState } from "store/hocs";

import { splitProfileListConstants } from "./splitProfileList.constants";

const initialState = {
	page: 0,
	queryParams: {
		pageIndex: 0,
	},
};

export const getSplitProfileListState = state => state.splitProfileList;

//prettier-ignore
const selector = property =>
	fp.flow(getSplitProfileListState, fp.property(property));

export const getSplitProfileListPage = selector("queryParams.pageIndex");

export const getSplitProfileListSortBy = selector("queryParams.sortBy");

export const getSplitProfileListSortDescending = selector("queryParams.isDescending");


function splitProfileList(state = initialState, action) {
	switch (action.type) {

		case splitProfileListConstants.SET_SORTING:
			return {
				...state,
				queryParams: {
					...state.queryParams,
					isDescending: action.isDescending,
					sortBy: action.sortBy,
				},
			};
		case splitProfileListConstants.SET_PAGING:
			return {
				...state,
				queryParams: {
					...state.queryParams,
					pageIndex: action.pageIndex,
					pageSize: action.pageSize,
				},
			};

		default:
			return state;
	}
}

export default withResetState({ initialState })(splitProfileList);
